import PropTypes from 'prop-types';

export default PropTypes.shape({
  type: PropTypes.oneOf(['link', 'pdf', 'image', 'video']),
  body: PropTypes.string.isRequired,
  url: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
});



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalSourceShape.js